<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  watch: {
    $route: {
      handler(newV, oldV) {
        const title = newV.meta.title || '达州市高新区节能标准信息网'
        document.title = title
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
<style lang="less">
  @import "./style/commonStyle";
  body{
    margin: 0;
    font-family: 微软雅黑;
  }
</style>
